<div class="width-full is-display-flex is-justify-content-center">
  <acs-expand-button [expanded]="expanded" (expandClick)="onExpandClick()"></acs-expand-button>
</div>
@if (expanded) {
  <div class="table-wrapper">
    <table class="width-full">
      <thead>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.header.guarantee' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.header.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.header.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.header.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.header.platinum' | translate"></div></td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.max_limit_beneficiary_year.title' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.max_limit_beneficiary_year.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.max_limit_beneficiary_year.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.max_limit_beneficiary_year.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.max_limit_beneficiary_year.platinum' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.hospitalisation.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.hospitalisation.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.hospitalisation_bis.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.hospitalisation_bis.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.specific_room.title' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.specific_room.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.specific_room.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.specific_room.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.specific_room.platinum' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.organ.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.organ.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.cancer_care.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.cancer_care.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.psychiatric_hospitalisation.title' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.psychiatric_hospitalisation.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.psychiatric_hospitalisation.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.psychiatric_hospitalisation.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.psychiatric_hospitalisation.platinum' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.accompanying_bed.title' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.accompanying_bed.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.accompanying_bed.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.accompanying_bed.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.accompanying_bed.platinum' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.extern_care_related_hospitalisation.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.extern_care_related_hospitalisation.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.home_hospitalisation.title' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.home_hospitalisation.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.home_hospitalisation.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.home_hospitalisation.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.home_hospitalisation.platinum' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.rehabilitation.title' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.rehabilitation.bronze' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.rehabilitation.silver' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.rehabilitation.gold' | translate"></div></td>
        <td><div [innerHtml]="'tarificateur.table.rehabilitation.platinum' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.ambulance_transport.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.ambulance_transport.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.dental_care_after_accident.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.dental_care_after_accident.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.emergency_care.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.emergency_care.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.emergency_hospitalisation.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.emergency_hospitalisation.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.evacuation_care.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.evacuation_care.all' | translate"></div></td>
      </tr>
      <tr>
        <td><div [innerHtml]="'tarificateur.table.consolidation_after_evacuation.title' | translate"></div></td>
        <td colspan="4"><div [innerHtml]="'tarificateur.table.consolidation_after_evacuation.all' | translate"></div></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
    <span class="label-tarification-accent">{{ 'tarificateur.table.footer' | translate }}</span>
    <a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a>
    <acs-expand-button [expanded]="expanded" (expandClick)="onExpandClick()"></acs-expand-button>
  </div>
}
